import { useEffect, useState } from 'react'
import Input from 'src/Components/Form/Input'
import TextArea from 'src/Components/Form/TextArea'
import { ICaseStudy } from 'src/utils/Interfaces/caseStudies.interface'
import style from './style.module.scss'
import { useUpdateCaseStudyMutation } from 'src/redux/Api/caseStudiesApi'

type Props = {
  data: ICaseStudy
}

type Preview1 = {
  product?: string
  experiment?: string
  resultName?: string
  resultValue?: string
}

type Preview2 = {
  product?: string
  goal?: string
  improvement?: string
  goals?: { name: string; value: string }[]
}

const AdditionalInfo = ({ data }: Props) => {
  const [preview1, setPreview1] = useState<Preview1>(data.preview1)
  const [preview2, setPreview2] = useState<Preview2>(data.preview2)
  const [updateCaseStudy] = useUpdateCaseStudyMutation()

  const updateGoalName = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
    const newGoals = (preview2.goals || []).map((goal, index) =>
      index === i ? { ...goal, name: e.target.value } : goal
    )
    setPreview2({ ...preview2, goals: newGoals })
  }

  const updateGoalValue = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
    const newGoals = (preview2.goals || []).map((goal, index) =>
      index === i ? { ...goal, value: e.target.value } : goal
    )
    setPreview2({ ...preview2, goals: newGoals })
  }

  const savePreview2 = () => {
    updateCaseStudy({
      id: data.id,
      preview2: preview2
    })
  }

  const savePreview1 = () => {
    updateCaseStudy({
      id: data.id,
      preview1: preview1
    })
  }
  useEffect(() => {
    console.log(preview2)
  }, [preview2])
  return (
    <>
      <div className={style.preview1}>
        <h3>Preview1</h3>
        <div>
          <TextArea
            className="light border"
            label="Product"
            name="additionalInfo"
            value={preview1.product || ''}
            onChange={(e) => setPreview1({ ...preview1, product: e.target.value })}
          ></TextArea>
          <TextArea
            className="light border"
            label="Experiment"
            name="additionalInfo"
            value={preview1.experiment || ''}
            onChange={(e) => setPreview1({ ...preview1, experiment: e.target.value })}
          ></TextArea>
          <Input
            label="Result name"
            className="light border"
            value={preview1.resultName || ''}
            onChange={(e) => setPreview1({ ...preview1, resultName: e.target.value })}
          />
          <Input
            label="Result value"
            className="light border"
            value={preview1.resultValue || ''}
            onChange={(e) => setPreview1({ ...preview1, resultValue: e.target.value })}
          />
        </div>
        {JSON.stringify(data.preview1) !== JSON.stringify(preview1) && (
          <button className="btn green" onClick={savePreview1}>
            Save
          </button>
        )}
      </div>

      <div className={style.preview2}>
        <h3>Preview2</h3>
        <div>
          <TextArea
            className="light border"
            label="Product"
            name="additionalInfo"
            value={preview2.product || ''}
            onChange={(e) => setPreview2({ ...preview2, product: e.target.value })}
          ></TextArea>
          <Input
            label="Our goal"
            className="light border"
            value={preview2.goal}
            onChange={(e) => setPreview2({ ...preview2, goal: e.target.value })}
          />
          <Input
            label="Areas of improvement"
            className="light border"
            value={preview2.improvement || ''}
            onChange={(e) => setPreview2({ ...preview2, improvement: e.target.value })}
          />
          {preview2.goals &&
            preview2.goals.map((goal, i: number) => {
              return (
                <div key={i} className={style.goal}>
                  <Input
                    label="Goal"
                    className="light border"
                    value={goal.name || ''}
                    onChange={(e) => updateGoalName(e, i)}
                  />
                  <Input
                    label="Value"
                    className="light border"
                    value={goal.value || ''}
                    onChange={(e) => updateGoalValue(e, i)}
                  />
                </div>
              )
            })}
        </div>
        {(!preview2.goals || preview2.goals.length < 2) && (
          <button
            className="btn"
            onClick={() =>
              setPreview2({ ...preview2, goals: [...(preview2.goals || []), { name: 'newGoal', value: '10%' }] })
            }
          >
            Add goal
          </button>
        )}
        {preview2.goals && preview2.goals.length > 0 && (
          <button
            className="btn"
            onClick={() => setPreview2({ ...preview2, goals: preview2.goals?.slice(0, preview2.goals.length - 1) })}
          >
            Remove goal
          </button>
        )}
        {JSON.stringify(data.preview2) !== JSON.stringify(preview2) && (
          <button className="btn green" onClick={savePreview2}>
            Save
          </button>
        )}
      </div>
    </>
  )
}

export default AdditionalInfo
